function getWindowOrigin() {
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    return ''
  }
  return window.location.origin.replace(/\/$/, '')
}

function isLocalHost(host = '') {
  return host === 'localhost' || host === '127.0.0.1'
}

function normalizeComparableHost(host = '') {
  return String(host || '').toLowerCase().replace(/^www\./, '')
}

function buildMediaProxyUrl(path) {
  const origin = getWindowOrigin()
  if (!origin) {
    return path
  }

  const host = (window.location.hostname || '').toLowerCase()
  const gatewayPrefix = isLocalHost(host) ? '' : '/prod-api'
  return `${origin}${gatewayPrefix}${path}`
}

function extractProxyPath(raw) {
  const profileIndex = raw.indexOf('/profile/')
  if (profileIndex !== -1) {
    return raw.substring(profileIndex)
  }

  const miniProfileIndex = raw.indexOf('/miniprogram-profile/')
  if (miniProfileIndex !== -1) {
    return raw.substring(miniProfileIndex)
  }

  if (raw.startsWith('profile/')) {
    return `/${raw}`
  }

  if (raw.startsWith('miniprogram-profile/')) {
    return `/${raw}`
  }

  return ''
}

export function resolveMediaUrl(value) {
  let raw = String(value || '').trim()
  if (!raw) return ''

  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    try {
      const url = new URL(raw)
      const host = (url.hostname || '').toLowerCase()
      const currentHost = typeof window !== 'undefined' && window.location ? (window.location.hostname || '').toLowerCase() : ''
      if (isLocalHost(host) || (currentHost && normalizeComparableHost(host) === normalizeComparableHost(currentHost))) {
        raw = `${url.pathname}${url.search || ''}`
      } else {
        return raw
      }
    } catch (e) {
      return raw
    }
  }

  const proxyPath = extractProxyPath(raw)
  if (proxyPath) {
    return buildMediaProxyUrl(proxyPath)
  }

  if (raw.startsWith('/')) return raw
  return raw
}



// WEBPACK FOOTER //
// ./src/utils/mediaUrl.js